import { get } from 'lodash';
import * as asyncActionCreator from '../../redux/actionCreators/async';
import * as syncActionCreator from '../../redux/actionCreators/sync';

import * as jobRequestApi from '../../redux/actionCreators/async/jobrequests';
import * as jobRequestDocumentsApi from '../../redux/actionCreators/async/jobrequestDocuments';
import * as companyApi from '../../redux/actionCreators/async/companies';
import * as jobRequestStore from '../../redux/actionCreators/sync/jobrequests';
import * as jobRequestDocumentsStore from '../../redux/actionCreators/sync/jobrequestDocuments';
import * as companyStore from '../../redux/actionCreators/sync/companies';

export default function OnEnterLoadJobRequest(store, isAdmin) {
  return (nextState, replace, done) => {
    const state = store.getState();

    let action;
    if(nextState.location.query.hasOwnProperty('clone')) {
      action = 'clone';
    } else if(nextState.params.jobId) {
      action = 'edit';
    } else {
      action = 'create';
    }

    if (action === 'edit') {

      const profileId = get(state, 'user.profileId');
      const companyId = get(state, 'user.companyId');
      const jobId = nextState.params.jobId;

      const promises = [];

      if (isAdmin) {
        promises.push(store.dispatch(jobRequestApi.getJobRequestById(nextState.params.jobId)));
        promises.push(store.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(profileId, jobId)));
        promises.push(store.dispatch(asyncActionCreator.searchContacts([])));
      }
      else {
        promises.push(store.dispatch(jobRequestApi.getJobRequest(profileId, nextState.params.jobId)));
        promises.push(store.dispatch(jobRequestDocumentsApi.getJobRequestDocuments(profileId, jobId)));
        promises.push(store.dispatch(companyApi.getCompanyContacts(companyId)) );

      }

    return Promise
      .all(promises)
      .then(([JobRequests, documents, contacts]) => {

        if (JobRequests[0].id) {
          store.dispatch(jobRequestStore.createJobRequest(JobRequests[0]));
        }

        if (documents) {
          store.dispatch(jobRequestDocumentsStore.createJobRequestDocuments(documents));
        }

        if (isAdmin) {

          if (contacts) {
            store.dispatch(syncActionCreator.updateContactsList(contacts));
          }

          return store.dispatch(companyApi.getCompanyContacts(JobRequests[0].companyId))
            .then((companyContacts) => store.dispatch(companyStore.updateCompanyContacts(get(companyContacts, 'body.data.items', []))))
            .then(() => done());
        }
        else {
          if (contacts && !isAdmin) {
            const companyContacts = get(contacts, 'body.data.items', []);
            store.dispatch(companyStore.updateCompanyContacts(companyContacts));
          }

          return done();
        }

        return done();
      })
      .catch((err) => {
         return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
      });

    }
    else if(action === 'clone') {
      
      return done();
    }
    else if(action === 'create') {

      store.dispatch(jobRequestStore.resetJobRequest());
      store.dispatch(jobRequestDocumentsStore.resetJobRequestDocuments());

      return done();

    }

    done();

  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadJobRequest.js